// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".verify-email-block{width:100%}.verify-email-block .envelope-container{position:relative}.verify-email-block .envelope-container .envelope{transform:scaleY(.8)}.verify-email-block .envelope-container .check{background:var(--v-accentBlue-base);border:1px solid #fff;border-radius:50%;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;position:absolute;bottom:23px;right:-3px}", ""]);
// Exports
module.exports = exports;
